
import Navbar from "./Components/Navbar";
import "./App.css";
import { createContext, useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Reset from "./Pages/Reset";
import { HomeFilter } from "./Pages/HomeFilter";
import { filterData } from "./Data/FilterData";
import { status } from "./constants";
import { AccountSettings } from "./Pages/AccountSettings";
import { Footer } from "./Components/Footer/Footer";
import { Homepage } from "./Pages/Homepage";
import { Plans } from "./Pages/Plans";
import { AllFlows } from "./Pages/AllFlows";
import Registration from "./Pages/Registration";
import { FAQ } from "./Pages/FAQ";
import { Blog } from "./Pages/Blog";
import BlogDetail from "./Components/Blog/BlogDetail";
import { AuthorProfilePage } from "./Pages/AuthorProfilePage";
import { ProductPageNew } from "./Components/ProductPage/ProductPageNew";
import { AuthorDashboardPage } from "./Pages/AuthorDashboardPage";
import useOutsideClick from "./utils/useOutsideClick";
import { Checkout } from "./Pages/Checkout";
import { CreateNewPassword } from "./Pages/CreateNewPassword";

export const AppContextProvider = createContext();

function App() {
  const [login, setLogin] = useState(false);
  const [resetSent, setResetSent] = useState('');
  const [allFilteredItems, setAllFilteredItems] = useState(null);
  const [filteredItems, setFilteredItems] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [showMobileAccMenu, setShowMobileAccMenu] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showMobileAuthorMenu, setShowMobileAuthorMenu] = useState(false);
  const [cancelBtn, setCancelBtn] = useState(true);
  const [showAfterApplyFilter, setShowAfterApplyFilter] = useState(false);

  const [addProductItems, setAddProductItems] = useState([])
  
  const savedMode = localStorage.getItem("dark");
  const [darkMode, setDarkMode] = useState(() => {
    // Check localStorage for user preference, default to false if not set
    return savedMode ? JSON.parse(savedMode) : false;
  });

  const showMobileMenuRef = useOutsideClick(() => setShowMobileMenu(false));
  const toggleTheme = (input) => {
    if(input === 'light'){
      setDarkMode(false)
    }
    if(input === 'dark'){
      setDarkMode(true)
    }
  };



  useEffect(() => {
    // Update localStorage when dark mode changes
    localStorage.setItem('dark', JSON.stringify(darkMode));
    // Apply or remove dark mode class from HTML element
    document.documentElement.classList.toggle('dark', darkMode);
  }, [darkMode]);


  const clearFilter = () => {
    setFilteredItems([]);
    document
      .querySelectorAll('input[type="checkbox"]')
      .forEach((e) => (e.checked = false));
    setCancelBtn(true);
  };

  useEffect(() => {
    if (filteredItems.length < 1) {
      clearFilter();
      setShowAfterApplyFilter(false);
    }
    
    if(filteredItems.length > 0){
      setCancelBtn(false)
    }
    
    const handleResize = () => {
      if(window.innerWidth >= 768){
        setShowAfterApplyFilter(true);
      }
     }
     
     window.addEventListener('resize', handleResize);
     
     return () => {
      window.removeEventListener('resize', handleResize);
     };

     
    }, [filteredItems.length]);
    


  const setStatus = (root, status) => {
    root.status = status;
    if (Array.isArray(root.items)) {
      // setFilteredItems(prev => [...prev,root.items])
      return root.items.forEach((item) => {
        setStatus(item, status);
        if(status === 1){
          console.log(item)
          setFilteredItems(prev => [...prev,item])
        } else {
          
          setFilteredItems([])
        }
      
      });
    }
    filteredItems.map((item,i) => {
      if(item.status === 0){
        filteredItems.splice(i,1)
      }
    })
  };
  
  const computeStatus = (items) => {
    let checked = 0;
    let indeterminate = 0;

    items.forEach((item) => {
      if (item.status && item.status === status.checked) checked++;
      if (item.status && item.status === status.indeterminate) indeterminate++;
    });

    if (checked === items.length) {
      return status.checked;
    } else if (checked > 0 || indeterminate > 0) {
      return status.indeterminate;
    }
  };

  // Depth-first traversal
  const traverse = (root, needle, status) => {
    let id;
    let items;

    if (Array.isArray(root)) {
      items = root;
    } else {
      id = root.id;
      items = root.items;
    }

    // return if needle is found
    // we don't have to compute the status of the items if root.id === needle
    if (id === needle) {
      return setStatus(root, status);
    }

    if (!items) {
      return root;
    } else {
      items.forEach((item) => traverse(item, needle, status));
      root.status = computeStatus(items);
    }
  };

  const [items, setItems] = useState(filterData);
  const compute = (checkboxId, status) => {
    traverse(items, checkboxId, status);
    setItems(items.slice());
  };
  const handleShowMenu = () => {
    if (window.location.pathname !== "/Pages/authorDashboard") {
      setShowMobileMenu(prev => !prev);
      setShowMobileAuthorMenu(false);
    }
    if (window.location.pathname === "/Pages/authorDashboard") {
      setShowMobileAuthorMenu(prev => !prev);
      setShowMobileMenu(false);
    }
  };
  
  const handleCloseMenu = () => {
    if (window.location.pathname === "/") {
      setShowMobileMenu(false);
      setShowMobileAuthorMenu(false);
    }
    if (window.location.pathname === "/Pages/authorDashboard") {
      setShowMobileAuthorMenu(false);
      setShowMobileMenu(false);
    }
  };


  const values = {
    setAllFilteredItems,
    allFilteredItems,
    showAfterApplyFilter,
    setShowAfterApplyFilter,
    clearFilter,
    setCancelBtn,
    cancelBtn,
    showFilter,
    setShowFilter,
    login,
    setLogin,
    filteredItems,
    setFilteredItems,
    compute,
    items,
    showMobileAccMenu,
    showMobileMenu,
    showMobileAuthorMenu,
    handleCloseMenu, handleShowMenu,
    setShowMobileAccMenu,
    resetSent,
    setResetSent,
    toggleTheme,
    darkMode,
    showMobileMenuRef,
    addProductItems, setAddProductItems
  };
  return (
    <div className={`${darkMode ? "dark" : "light" } dark:bg-[#1C1C1C] dark:text-[#CCCCCC] min-h-screen`}>
      <AppContextProvider.Provider value={values}>
        <Navbar />
        <BrowserRouter>
          <Routes>
            <Route index element={<Homepage />} />
            <Route path="/Pages/Registration" element={<Registration />} />
            <Route path="/Pages/Plans" element={<Plans />} />
            <Route path="/Pages/AllFlows/:id" element={<AllFlows />} />
            <Route path="/Pages/HomeFilter" element={<HomeFilter />} />
            <Route path="/Pages/AccountSettings/:id" element={<AccountSettings />} />
            <Route path="/Pages/ProductPage" element={<ProductPageNew />} />
            <Route path="/Pages/Reset" element={<Reset />} />
            <Route path="/Pages/FAQ" element={<FAQ />} />
            <Route path="/Pages/Blog" element={<Blog />} />
            <Route path="/Pages/Checkout" element={<Checkout />} />
            <Route path="/Pages/CreateNewPassword" element={<CreateNewPassword />} />
            <Route path="/Pages/Blog/Detail" element={<BlogDetail />} />
            <Route path="/Pages/authorDashboard" element={<AuthorDashboardPage />} />
            <Route path="/Pages/Author/AuthorProfile" element={<AuthorProfilePage />} />
          </Routes>
        </BrowserRouter>
        <Footer/>
      </AppContextProvider.Provider>
    </div>
  );
}

export default App;
